module.exports = __webpack_public_path__ + "media/images/flags/16/Nauru-caf372f916fa6e56a7c4e341ef9609de.png";